import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/p/erro/")({
	validateSearch: (search: Record<string, unknown>): { error: string } => {
		return {
			error: search.error as string,
		};
	},
});
